<template>
  <div>
    <article class="checkin-list-item">

      <header class="checkin-list-item__header">
        <div class="d-flex justify-content-between align-items-start">
          <a href="#" class="d-block w-100" @click.prevent="emitOpenCheckinDetail(true)">
            <h2 class="checkin-list-item__header__heading">{{ checkin.pica_service.event_name }}</h2>
            <div class="checkin-list-item__header_holder">
            <span class="checkin-list-item__header__status-icon"
                  v-if="! checkin.pica_service.is_tagging_completed">
            </span>
              <span class="checkin-list-item__header__subheading">{{ checkin.pica_service.event_photo_service }}</span>
            </div>
          </a>

          <!-- CONTEXT MENU -->
          <checkin-context-menu
              :checkin="checkin"
              @remove-album="$emit('item-remove')"
              @anonymize-album="$emit('anonymize')"
              @show-qr-picacode="$emit('show-qr-picacode')"
              @download-album="$emit('download-album')"/>
        </div>
      </header>

      <a href="#" @click.prevent="emitOpenCheckinDetail(false)">
        <section class="checkin-list-item__photos" :class="{'has-more-photos': morePhotosCount > 1}"
                 v-if="photosLoaded">
          <template v-if="photos.length === 0">
            <template v-if="checkin.user_cta==='none'">
              <div class="checkin-list-item__photo-item" v-for="index in 5" :key="index"
                   :data-index="index">
                <div class="checkin-list-item__photo-item__img"></div>
              </div>
            </template>
            <div class="checkin-list-item__photos__none" v-else-if="checkin.user_cta === 'support'">
              <div class="message-list text-center">
                <h6 class="checkin-list-item__photos__none__title mb-3">
                  {{ $t('pages.checkins.sorry_no_photo_found') }}
                </h6>
                <div>
                  <a href="" class="btn btn__icon btn__icon--fly btn-primary">{{ $t('pages.checkins.contact_us') }}</a>
                </div>
              </div>
            </div>
            <div class="checkin-list-item__photos__none" v-else-if="checkin.user_cta === 'face-checkin'">
              <div class="message-list text-center">
                <h6 class="checkin-list-item__photos__none__title mb-3">{{ $t('pages.checkins.no_photo_found') }}</h6>
                <div>
                  <a href="" class="btn btn__icon btn__icon--search-selfie btn-primary">
                    {{ $t('pages.checkins.search_with_selfie') }}</a>
                </div>
              </div>
            </div>
            <div class="checkin-list-item__photos__none" v-else>
              <div class="text-center">
                <h4 class="checkin-list-item__photos__none__title">
                  {{ $t('pages.checkins_list.photos_available_soon_title') }}</h4>
                <h5 class="checkin-list-item__photos__none__desc mt-2 text-secondary">
                  {{ $t('pages.checkins_list.photos_available_soon_message') }}
                </h5>
              </div>
            </div>
          </template>
          <template v-else>
            <div class="checkin-list-item__photo-item" v-for="(photo, index) in photosPadded" :key="index">
              <img v-lazy="photo.image_url" class="checkin-list-item__photo-item__img" v-if="photo && photo.image_url"/>
              <div class="checkin-list-item__photo-item__img" v-else></div>
              <div class="badge" v-if="(morePhotosCount > 1 && index === photosPadded.length - 1)">
                +{{ morePhotosCount }}
              </div>
            </div>
          </template>
        </section>
      </a>
      <div class="checkin-list-item__footer" v-if="showAnonymizationSatus">
        <div class="checkin-list-item__anonymize d-flex align-items-center">
          <span class="checkin-list-item__anonymize--icon"></span>
          <span class="checkin-list-item__anonymize--text">{{
              $t('pages.checkins_detail.anonymous_mode_on')
            }}</span>
        </div>
      </div>
    </article>

  </div>
</template>


<script>
import {getContactUrl} from "@/utils";
import {ANONYMIZATION_STATUS} from "@/components/ModalAnonymizeCheckin.vue";
import CheckinContextMenu from "@/components/CheckinContextMenu.vue";
export default {

  props: ['checkin'],

  components: {
    CheckinContextMenu
  },
  created() {
    this.ANONYMIZATION_STATUS = ANONYMIZATION_STATUS
  },
  data() {
    return {
      photosLoaded: false,
      photosLimit: 5,
      openFaceRecognitionModalAfterClick: false
    }
  },

  mounted() {
    console.log('CREATED CheckinListItem')
    this.photosLoaded = true
  },

  computed: {
    showAnonymizationSatus() {
      return this.checkin.anonymize_status !== this.ANONYMIZATION_STATUS.unavailable && this.checkin.anonymize_status === this.ANONYMIZATION_STATUS.completed
    },
    photos() {
      return this.checkin.photos_summary.slice(0, this.photosLimit)
    },
    photosPadded() {
      return Array.from({...this.photos, length: 5})
    },
    photosCount() {
      return this.checkin.photos_count
    },
    morePhotosCount() {
      const displayed_preview_photos = 4
      return this.photosCount - displayed_preview_photos
    },
    isTwelveHoursOverEventEnd() {
      let twelveHoursEventEnd = new Date(this.checkin.pica_service.event_end_at)
      twelveHoursEventEnd.setHours(twelveHoursEventEnd.getHours() + 12)
      return new Date() > twelveHoursEventEnd
    },
    openFaceRecognitionAfterClick() {
      return this.checkin.user_cta === 'face-checkin'
    },
    contactUrl() {
      return getContactUrl(`${this.checkin.pica_service.event_name} | ${this.checkin.picacode}`)
    }
  },

  methods: {
    emitOpenCheckinDetail(forceCheckDetail) {
      // console.log('force ', forceCheckDetail)
      if (this.checkin.user_cta === 'support' && !forceCheckDetail) {
        window.open(this.contactUrl)
      } else {
        this.$emit('item-clicked', {
          openFaceReconition: this.openFaceRecognitionAfterClick && !forceCheckDetail,
          checkinId: this.checkin.id,
          picacode: this.checkin.picacode,
          picaServiceId: this.checkin.pica_service.id
        })
      }
    }

  }
}
</script>
